import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 19h12v2H6z"
}), 'Minimize');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Minimize.js
// module id = 4841
// module chunks = 2